import React from 'react';
import { Box, Container, Paper, Tab, Tabs } from '@material-ui/core';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import StorefrontIcon from '@material-ui/icons/Storefront';
import { makeStyles } from '@material-ui/styles';
import { useState } from 'react';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import SalesKatalog from './SalesKatalog';
import SatisFiyat from './SalesPrice';
import SatisTodos from './SalesTodos';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    backgroundColor: theme.palette.background.dark
  },
  tabsContainer: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderRadius: 12,
  },
  tabContent: {
    marginTop: theme.spacing(2),
    transition: 'all 0.3s'
  }
}));

function Satis() {
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Page className={classes.root} title="Satış Yönetimi">
      <Container maxWidth="lg">
        <Header />
        
        <Paper className={classes.tabsContainer} elevation={1}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab icon={<StorefrontIcon fontSize="small" />} label="FIRSATLAR" />
            <Tab icon={<MenuBookIcon fontSize="small" />} label="KATALOGLAR" />
            <Tab icon={<LocalOfferIcon fontSize="small" />} label="FİYATLAR" />
          </Tabs>
        </Paper>

        <Box className={classes.tabContent}>
          {currentTab === 0 && <SatisTodos />}
          {currentTab === 1 && <SalesKatalog />}
          {currentTab === 2 && <SatisFiyat />}
        </Box>
      </Container>
    </Page>
  );
}

export default Satis;